import React from 'react';
import { portraitForThisLoad } from '../../portraits';
import './style.css';

const heroPortrait = portraitForThisLoad();

function Info() {
  return (
    <section id="about" className="hero">
      <div className="hero-copy">
        <span className="eyebrow">Actor · Singer · Dancer</span>
        <h1>Paige<br /><em>Faure</em></h1>
        <div className="hero-rule" />
        <p className="hero-lead">Paige is a versatile, true triple-threat performer based in NYC.</p>
        <p className="hero-description">A creative and compelling actor, Paige approaches her work with humor, depth, and curiosity.</p>
        <div className="hero-actions">
          <a className="button button-dark" href="#videos">Watch Paige perform <span aria-hidden="true">↗</span></a>
          <a className="text-link" href="#resume">Explore resume <span aria-hidden="true">→</span></a>
        </div>
      </div>
      <div className="hero-visual">
        <img src={heroPortrait} alt="Portrait of Paige Faure" fetchPriority="high" />
        <span className="hero-image-caption">Paige Faure / New York City</span>
      </div>
    </section>
  );
}

export default Info;
